import 'primeicons/primeicons.css';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/lara-light-purple/theme.css';
import { createGlobalStyle } from 'styled-components';

import FontProximaNovaThnReg from '../../../assets/fonts/1274139/764133da-a9ba-492a-8026-22889acd7f12.woff2';
import FontProximaNovaReg from '../../../assets/fonts/1274151/781c5453-0067-4e64-9386-7c0726d63d57.woff2';
import FontProximaNovaSmbd from '../../../assets/fonts/1274157/672e09ff-117f-47a9-ad39-2af9420ccb79.woff2';

export default createGlobalStyle`
  @font-face {
    font-family: "Proxima Nova W08 Thn Reg";
    src: url("${FontProximaNovaThnReg}") format("woff2");
  }

  @font-face {
    font-family: "Proxima Nova W08 Reg";
    src: url("${FontProximaNovaReg}") format("woff2");
  }

  @font-face {
    font-family: "Proxima Nova W08 Smbd";
    src: url("${FontProximaNovaSmbd}") format("woff2");
  }

  body {
    font-size: 16px;
    font-family: "Proxima Nova W08 Reg", sans-serif;
    margin: 0;
  }
`;
